export const Bio = {
    name: "Md. Roni",
    roles: [
      "Web Developer",
      "Programmer"
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/Md-Roni024",
    resume:
      "https://drive.google.com/file/d/1otnLp-BcdxQj1h78ULk5hkIr1cGApeqj/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/roni-hossain-z24/",
    codeforces: "https://codeforces.com/profile/Roni24",
    leetcode: "https://leetcode.com/Roni_024/",
    insta: "https://www.instagram.com/roni.hossain.024/",
    facebook: "https://www.facebook.com/roni.hossain.024/",
    youtube: "https://www.youtube.com/@ronihossain7428"
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React.Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Scrapy",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/b/b4/Scrapy_logo.jpg",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "Tailwind CSS",
          image:
            "https://en.wikipedia.org/wiki/Tailwind_CSS#/media/File:Tailwind_CSS_logo.svg",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Angular",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/2/22/Angular_logo_%282023%29.svg",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        {
          name: "Material UI",
          image:
            "data:image/png;base64,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",
        },
        {
        name: "Redux",
          image:
            "https://en.wikipedia.org/wiki/Redux_(JavaScript_library)#/media/File:Redux_Logo.png",
        },
        
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node.Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
        {
        name: "Express.js",
          image: "https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png",
        },
        {
          name: "Typescript",
          image:
            "https://static.djangoproject.com/img/logos/django-logo-positive.png",
        },
        {
          name: "Flask",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Flask_logo.svg/1280px-Flask_logo.svg.png",
        },
      ],
    },
    {
      title: "Database",
      skills: [
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        },
        {
          name: "PostgreSql",
          image: "https://wiki.postgresql.org/images/a/a4/PostgreSQL_logo.3colors.svg",
        },
        {
          name: "Firebase",
          image:
            "https://en.wikipedia.org/wiki/Firebase#/media/File:New_Firebase_logo.svg",
        },
      ],
    },
    {
      title: "Machine Learning",
      skills: [
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "Tensorflow",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg",
        },
        {
          name: "Keras",
          image:
            "https://miro.medium.com/v2/resize:fit:600/1*DKu_54iqz6C-p6ndo7rO3g.png",
        },
        {
          name: "Jupyter",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
        },
        {
          name: "Google Colab",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/d/d0/Google_Colaboratory_SVG_Logo.svg",
        },
        {
          name: "Sk Learn Kit",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
        },
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Docker",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        },
        {
          name: "Postman",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/c/c2/Postman_%28software%29.png",
        },

      ],
    },
  ];
  
  export const experiences = [
    {
      id: 1,
      img: "",
      role: "Software Engineer Intern",
      company: "BJIT Ltd.",
      date: "Sep 2024 - Jan 2025",
      desc: "",
      skills: [
        "Angular",
        "Typescript",
        "SDLC",
        "Git/Gerrit",
        "REST API",
        "JavaScript",
      ],
      doc: "",
    },
    {
      id: 2,
      img: "",
      role: "Junior Fullstack Software Engineer",
      company: "Implevista LTD.",
      date: "Mar 2025 - ",
      desc: "",
      skills: [
        "Angular",
        "Typescript",
        "Node.js",
        "Express.js",
        "Git",
        "Firebase",
        "Figma",
        "Redux",
        "Map API",
      ],
      doc: "",
    },

  ];
  
  export const education = [
    {
      id: 0,
      img: "https://my.pcloud.com//#page=filemanager&folder=20584711711&tpl=folderlist",
      school: "Gopalganj Science & Technology University(GSTU)",
      date: "Jan 2019 - Sep 2024",
      grade: "First Class",
      desc: "I am completed a Bachelor's degree in Computer Science and Engineering from Gopalganj Science & Technology University,Gopalganj.I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
      degree: "Bachelor of Science, Computer Science and Engineering",
    },
    {
      id: 1,
      img: "",
      school: "Hajiganj Govt. Model College,Chandpur",
      date: "May 2015 - Apr 2017",
      grade: "A",
      desc: "I completed my higher secondary school education at Hajiganj Govt. Model College, Chandpur.",
      degree: "HSC",
    },
    {
      id: 2,
      img: "",
      school: "Maisaid P.M.A.G High School,Hajiganj,Chanpur",
      date: "Jan 2010 - Jan 2015",
      grade: "A",
      desc: "I completed my secondary education at Maisaid P.M.A.G High School,Hajiganj,Chanpur.",
      degree: "SSC",
    },
  ];
  
  export const projects = [
    {
      id: 0,
      title: "Test_Yourself-Quiz_Apps",
      date: "October 2023",
      description:
        "This simple static quiz app, where a user answers several MCQ types of questions and after completing the test sees the score with the correct answer sheet.",
      image:
        "https://raw.githubusercontent.com/Md-Roni024/Test_Yourself-Quiz_Apps/main/quiz.svg",
      tags: ["Dart", "Flutter"],
      category: "android app",
      github: "https://github.com/Md-Roni024/Test_Yourself-Quiz_Apps"
    },
    {
      id: 1,
      title: "Blood-Donation-Apps",
      date: "Mar 2022",
      description:
        "Blood donation apps for easy blood donate,user can create account either as donor or reciver,search doner or reciver.Also can send direct mail or call to anyone.",
      image:
        "https://raw.githubusercontent.com/Md-Roni024/Blood-Donation-Apps/main/blood_donation.svg",
      tags: ["Java", "XML","Firebase"],
      category: "android app",
      github: "https://github.com/Md-Roni024/Blood-Donation-Apps"
    },
    {
      id: 2,
      title: "Dice Roller",
      date: "Mar 2022",
      description:
        "Dice roller app.",
      image:
        "https://raw.githubusercontent.com/Md-Roni024/DiceRoller/main/dice_roller_2.svg",
      tags: ["Dart", "Flutter"],
      category: "android app",
      github: "https://github.com/Md-Roni024/DiceRoller"
    },
    {
      id: 4,
      title: "Iris_Species_Classifier",
      date: "Dec 2023",
      description:
        "Irish Class specifier web app for classify 3 types of irish species.It show approximately 97% accuracy.",
      image:
        "https://raw.githubusercontent.com/Md-Roni024/Iris_Species_Classifier/main/iris.svg",
      tags: ["HTML","CSS","Python","TensorFlow", "Jupyter","Pickle", "Flask"],
      category: "machine learning",
      github: "https://github.com/Md-Roni024/Iris_Species_Classifier"
    },

    {
      id: 5,
      title: "Rice-Leaf-Disease Detection",
      date: "Dec 2023",
      description:
        "Use a neural network model called sequential model for prediction rice leaf disease. Here I use 6 types of Image and gain almost 90% accuracy. For frontend and backend development I used Python Flask framework and basic html,css. For building model I used jupyter notebook.",
      image:
        "https://lh3.googleusercontent.com/d/1RT9RCDgLUW8D-UbNwv4yg4_iwx35S01P=s220",
      tags: ["HTML","CSS","Python", "Keras", "TensorFlow", "", "Pickle", "Flask"],
      category: "machine learning",
      github: "https://github.com/Md-Roni024/Image_Classifier-Rice-Leaf-Disease-"
    },

    {
      id: 6,
      title: "CSE_FootballClub_CRUD",
      date: "Oct 2022",
      description:
        "CSE football club basically a crud app, where every deatails of player can store. Also possible to modify user ,delete user and so on.",
      image:
        "https://raw.githubusercontent.com/Md-Roni024/CSE_FootballClub_CRUD/main/CSE_logo.svg",
      tags: ["HTML","CSS","PHP","MySql","XAMPP"],
      category: "web app",
      github: "https://github.com/Md-Roni024/CSE_FootballClub_CRUD"
    },
    
    {
      id: 7,
      title: "NewsPaper_Using-free-API",
      date: "Jun 2023",
      description:
        "API integration website, building using a free news api.Viewer can see different types of news like science,entertainment,sports and so on.",
      image:
        "https://raw.githubusercontent.com/Md-Roni024/NewsPaper_Using-free-API/main/2kozOIy7pBAiyc5FwyTQFw7cASF.svg",
      tags: ["HTML","CSS","React.js","JavaScript","NewsAPI"],
      category: "web app",
      github: "https://github.com/Md-Roni024/NewsPaper_Using-free-API"
    },
    {
      id: 8,
      title: "TextModi-Change-Your-Text",
      date: "Jun 2023",
      description:
        "Text Modi is a simple website for modify text,like change text to upppercase or lowercase, Copy text & clear text. It has a simple navbar where user able to toggle the mode dark or light .",
      image:
        "https://upload.wikimedia.org/wikipedia/en/1/11/Fast_text.png",
      tags: ["HTML","CSS","React.js","JavaScript","NewsAPI"],
      category: "web app",
      github: "https://github.com/Md-Roni024/TextModi-Change-Your-Text"
    },
    {
      id: 9,
      title: "Airbnb Clone Project",
      date: "July 2024",
      description:
        "This project us basically clone of Airbnb, I build this project for deeply know about full stack development.In this project I build all the functionality like: location filter, date picker, guest count, modal & shimmer effect.",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/6/69/Airbnb_Logo_B%C3%A9lo.svg",
      tags: ["HTML","CSS","React.js","Node.js","Express.js","PotgreSql"],
      category: "web app",
      github: "https://github.com/Md-Roni024/Airbnb_Clone_Project"
    },
    {
      id: 10,
      title: "EcoSync – Manage Waste",
      date: "May 2024",
      description:
        "DNCC waste management system where waste transport,collection, landfill, workers, manager and billing are include. This project is build in the final round of Code Samurai Hackathon-2024. Me and my team ‘BSMRSTU_PREFECT_NUMBER’ Developed and implemented this project",
      image:
        "https://raw.githubusercontent.com/Md-Roni024/EcoSync-Waste-Management-System/master/waste_mange.svg",
      tags: ["HTML","CSS","React.js","Node.js","Express.js","MongoDb","Jwt Token"],
      category: "web app",
      github: "https://github.com/Md-Roni024/EcoSync-Waste-Management-System"
    },
    {
      id: 10,
      title: "Property Mangement System",
      date: "May 2024",
      description:
        "This project is mainly focused on manage property information. It's basically admin dashboard specific admin can add,update,delete & modify property.Also admin can add different types of user with specific roles and permission.",
      image:
        "https://raw.githubusercontent.com/Md-Roni024/Django_Assignment/master/dashboard.svg",
      tags: ["HTML","CSS","Django","PostgreSql"],
      category: "web app",
      github: "https://github.com/Md-Roni024/Django_Assignment"
    },
  ];



  export const certificates = [
    {
      id: 1,
      title: "Code Samurai Hackathon 2024",
      date: "May 2024",
      description:
        "I participate code samurai hackathon final round 2024. Along with others 41 team my team 'BSMRSTU_PREFECT_NUMBER' selected and participte the hacktahon. In this hackathon we are working in a real life project name: DNCC waste management system.",
      image:
        "https://raw.githubusercontent.com/Md-Roni024/Essential_Tools_Information/main/code_s.svg",
      link: "https://drive.google.com/file/d/12-FJs9Ede91bb6RqlOrOMheNWK-Cj4Ws/view?usp=sharing"
    },
    {
      id: 2,
      title: "Introduction To Python",
      date: "January 2024",
      description:
        "Basic python Course, I complete the course for both my academic fullfilment and python learning.",
      image:
        "https://raw.githubusercontent.com/Md-Roni024/Essential_Tools_Information/main/a_vidya_.svg",
      link: "https://courses.analyticsvidhya.com/certificates/zbd3nw7k7z"
    },
    {
      id: 3,
      title: "Sql(Basic) Certificate",
      date: "January 2024",
      description: "The SQL (Basic) Certificate demonstrates foundational knowledge of SQL, including querying databases, managing tables, and using basic functions. It validates the ability to work with relational databases and execute essential SQL commands,",
      image:
        "https://raw.githubusercontent.com/Md-Roni024/Essential_Tools_Information/main/sql.svg",
      link: "https://www.hackerrank.com/certificates/22f70f979035"
    },
    {
      id: 4,
      title: "Introduction to Agile Development and Scrum",
      date: "September 2023",
      description:
        "Introduction to Agile Development and Scrum course on Coursera provides a foundational understanding of Agile methodologies, with a focus on the Scrum framework. It covers key concepts like iterative development, sprints, and team roles, preparing learners to effectively participate in Agile projects.",
      image:
        "https://raw.githubusercontent.com/Md-Roni024/Essential_Tools_Information/main/agile_s.svg",
      link: "https://www.coursera.org/lecture/agile-development-and-scrum/the-3-roles-of-scrum-POMsh"
    },
    {
      id: 5,
      title: "Linux Fundamentals",
      date: "January 2024",
      description:
        "Linux Fundamentals course on Coursera introduces essential Linux concepts and commands, covering system navigation, file management, and permissions. It provides a solid foundation for understanding and using Linux in various computing environment",
      image:
        "https://raw.githubusercontent.com/Md-Roni024/Essential_Tools_Information/main/linux.svg",
      link: "https://www.coursera.org/learn/linux-fundamentals"
    }    

    // {
    //   id: 0,
    //   title: "Code Samurai Hackathon 2024",
    //   date: "October 2023",
    //   description:
    //     "This simple static quiz app, where a user answers several MCQ types of questions and after completing the test sees the score with the correct answer sheet.",
    //   image:
    //     "https://raw.githubusercontent.com/Md-Roni024/Test_Yourself-Quiz_Apps/main/quiz.svg",
    //   link: "https://github.com/Md-Roni024/Test_Yourself-Quiz_Apps"
    // },
    // {
    //   id: 0,
    //   title: "Code Samurai Hackathon 2024",
    //   date: "October 2023",
    //   description:
    //     "This simple static quiz app, where a user answers several MCQ types of questions and after completing the test sees the score with the correct answer sheet.",
    //   image:
    //     "https://raw.githubusercontent.com/Md-Roni024/Test_Yourself-Quiz_Apps/main/quiz.svg",
    //   link: "https://github.com/Md-Roni024/Test_Yourself-Quiz_Apps"
    // },
    // {
    //   id: 0,
    //   title: "Code Samurai Hackathon 2024",
    //   date: "October 2023",
    //   description:
    //     "This simple static quiz app, where a user answers several MCQ types of questions and after completing the test sees the score with the correct answer sheet.",
    //   image:
    //     "https://raw.githubusercontent.com/Md-Roni024/Test_Yourself-Quiz_Apps/main/quiz.svg",
    //   link: "https://github.com/Md-Roni024/Test_Yourself-Quiz_Apps"
    // }
  ];